import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ThemeProvider as JssThemeProvider } from 'react-jss'

import { isNewStylesThemeEnabledSelector, themeColorSelector } from '../../../modules/selectors/app'
import { selectedPartnershipSelector } from '../../../modules/selectors/partnerships'

import { RIGHTS_HOLDER_DOMAINS } from '../../../constants/RIGHTS_HOLDER_DOMAINS'
import { DOMAINS } from '../../../constants/selectLists/contriesList'

import { connectImgTheme } from '../../../styles/themes/connectImgTheme'
import { getAlulaXiTheme } from '../../../styles/themes/alulaXiTheme'
import { getDefaultTheme } from '../../../styles/themes/getDefaultTheme'
import { getCrowdCatchTheme } from '../../../styles/themes/crowdCatchTheme'

import { setElementVars } from '@vanilla-extract/dynamic'
import { themeVars } from './contract.css'

const getDomainTheme = ({ currentAppUrl, themeColor, isNewStylesThemeEnabled }) => {
  if (currentAppUrl.includes(DOMAINS.crowdcatch)) {
    return getCrowdCatchTheme(isNewStylesThemeEnabled)
  } else {
    return getDefaultTheme(themeColor, isNewStylesThemeEnabled)
  }
}

const getTheme = ({ rightsHolderSiteDomain = '', themeColor, currentAppUrl, isNewStylesThemeEnabled }) => {
  if (rightsHolderSiteDomain.includes(RIGHTS_HOLDER_DOMAINS.connectImg)) {
    const defaultTheme = getDefaultTheme(themeColor, isNewStylesThemeEnabled)
    return {
      ...defaultTheme,
      ...connectImgTheme
    }
  }
  if (rightsHolderSiteDomain.includes(RIGHTS_HOLDER_DOMAINS.alulaXi)) {
    const defaultTheme = getDomainTheme({ currentAppUrl, themeColor, isNewStylesThemeEnabled })
    return getAlulaXiTheme(defaultTheme)
  } else {
    return getDomainTheme({ currentAppUrl, themeColor, isNewStylesThemeEnabled })
  }
}

const StylesProvider = ({ children }) => {
  const themeColor = useSelector(themeColorSelector)
  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const isNewStylesThemeEnabled = useSelector(isNewStylesThemeEnabledSelector)
  const currentAppUrl = window.location.href

  const rightsHolderSiteDomain = selectedPartnership?.site?.domain

  const selectedTheme = useMemo(() => {
    return getTheme({
      rightsHolderSiteDomain,
      themeColor,
      currentAppUrl,
      isNewStylesThemeEnabled
    })
  }, [rightsHolderSiteDomain, themeColor, currentAppUrl, isNewStylesThemeEnabled])

  useEffect(() => {
    // writes CSS variables to :root, overriding the defaults
    // in other words it replaces the theme CSS variables with the new values
    setElementVars(document.documentElement, themeVars, selectedTheme)
  }, [selectedTheme])

  return <JssThemeProvider theme={selectedTheme}>{children}</JssThemeProvider>
}

export default StylesProvider
